<template>
  <UserContainer></UserContainer>
</template>

<script>
import UserContainer from './../views/messagesItem/UserDetails.vue';

export default {
  name: 'DefaultAside',
   components: {    
    UserContainer
  }
}
</script>
